export const REPORTING_V2_PERMISSIONS = {
    ACCESS: 'reporting_v2',
    READ: 'reporting_v2_read',
    CREATE: 'reporting_v2_create',
    UPDATE: 'reporting_v2_update',
    DELETE: 'reporting_v2_delete'
} as const
